module.exports = __webpack_public_path__ + "img/Hunan-speed.7b3eb5ed.png";